export default __webpack_public_path__ + "static/media/thumbs-up-v2.16dfc9b1.svg";